import React, { useEffect, useState } from 'react'
import { Modal, Row, OverlayTrigger, Tooltip } from 'react-bootstrap'
import variables from '../../Variables.json'
import api from '../../seller-apis/api'
import { useAlert } from 'react-alert'

/* ── inline styles for the package table ── */
const pkgTableStyle = {
    wrapper: {
        overflowX: 'auto',
        marginBottom: '10px',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '12px',
    },
    th: {
        background: '#165b5b',
        color: '#fff',
        padding: '6px 8px',
        textAlign: 'left',
        fontWeight: '600',
        whiteSpace: 'nowrap',
    },
    td: {
        padding: '5px 8px',
        borderBottom: '1px solid #eee',
        color: '#444',
        whiteSpace: 'nowrap',
    },
    sectionTitle: {
        fontSize: '13px',
        fontWeight: '700',
        color: '#165b5b',
        marginTop: '10px',
        marginBottom: '6px',
        paddingBottom: '4px',
        borderBottom: '2px solid #c5d6d6',
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
    },
}

const styles = {
    verifyManifestPopup: {
        headerDiv: {
            display: 'flex',
            width: '100%'
        },
        expTraPriceTag: {
            margin: 'auto',
            color: 'red',
        },
        headerBtns: {
            flex: 1,
            border: 'none',
            boxShadow: '0px 1px 0px 0.5px grey',
            padding: '4px 0px',
            fontSize: "14px"
        },
        vtpPara: {
            textAlign: 'left',
            fontSize: '16px',
            fontWeight: "bold"
        },
        imageBox: {
            height: "98px"
        },
        pName: {
            textAlign: 'left',
            fontSize: '16px',
            color: '#165b5b',
            margin: "10px 0 0",
        },
        sku: {
            textAlign: 'left',
        },
        confirmBtn: {},
        label: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '12px',
        },
        tpInput: {
            width: "120px",
            padding: '5px 8px 5px 28px',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            border: '1.5px solid #165b5b',
            borderRadius: '4px',
            fontSize: '14px',
        },
        gstInput: {
            fontSize: "13px",
            padding: "5px 8px",
            width: "120px",
            border: '1.5px solid #165b5b',
            borderRadius: '4px',
        },
        rsLabel: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            left: '8px',
            fontWeight: 'bold',
        },
        tpTitle: {
            color: 'black',
            width: '42%',
            textAlign: 'right',
            fontWeight: '600',
            fontSize: '14px',
        },
        sUpdateContainer: {
            width: '35%',
            textAlign: 'left',
            position: 'relative',
            marginBottom: '10px',
        },
        cStockInput: {
            width: "120px",
            padding: '5px 8px',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            border: '1.5px solid #165b5b',
            borderRadius: '4px',
            fontSize: '14px',
        },
        endBtnContainer: {
            textAlign: 'end',
            marginTop: '40px'
        },
        submitBtn: {
            color: '#fff',
            background: '#165b5b',
            borderRadius: '4px',
            padding: "4px 20px",
            borderStyle: 'none',
            fontSize: '15px',
            boxShadow: '0 .2em 1em -.2em #d0d0d0'
        },
        backBtn: {
            color: 'white',
            background: '#909090',
            borderRadius: '4px',
            padding: "4px 15px",
            borderStyle: 'none',
            fontSize: '15px',
            boxShadow: '0 .2em 1em -.2em #d0d0d0',
        },
        lowestPriceTag: {
                textAlign: 'center',
                background: 'none',
                border: 'none',
                borderRadius: '0',
                padding: '0',
                fontSize: '13px',
                fontWeight: '600',
                margin: '8px auto 16px auto',
                display: 'inline-block',
        },
        popupWrap: {
            alignItems: "start"
        },
        stpErrorMsg: {
            position: 'absolute',
            fontSize: '10px',
            left: 0,
            bottom: '-17px',
            fontWeight: '600',
        }
    }
}

const AddProductFromCataloguePopup = ({ lead, productName, Popupvisible, img, allImages, lowestPrice, detail, Popupvisibilityfun, callbackResFun }) => {
    // Helper to encode all path segments (folders and filename)
    const getEncodedImageUrl = (imgPath) => {
        if (!imgPath) return null;
        const parts = imgPath.split('/');
        const encodedParts = parts.map(segment => encodeURIComponent(segment));
        return `https://s3.toolsvilla.com/${encodedParts.join('/')}`;
    }
    const imageUrl = getEncodedImageUrl(img);
    const fallbackImage = null;
    const alert = useAlert();
    const [currentStep, setCurrentStep] = useState(0)
    const [verTrPrice, setVerTrPrice] = useState(null)
    const [currentStock, setCurrentStock] = useState(null)
    const [gst, setGst] = useState("");
    const [paginationIndex, setPaginationIndex] = useState(0);
    const [mainImg, setMainImg] = useState(img);
    const [showPriceError, setShowPriceError] = useState(false);
    const [showStockError, setShowStockError] = useState(false);
    const [stockError, setStockError] = useState('');

    useEffect(() => {
        setGst(detail?.taxClass || "0")
    }, [])

    // SL-1143 design changes and add image slide
    const changeImage = (item, index) => {
        setMainImg(getCleanImagePath(item.image));
        setPaginationIndex(index);
    }

    const getCleanImagePath = (imagePath) => {
        if (!imagePath) return "";
        if (imagePath.startsWith("products") || imagePath.startsWith("mob")) {
            return imagePath;
        }
        return imagePath.substr(41);
    }

    const scroll = (spcl) => {
        var doc = document.getElementById("category_popup_img_list_box_cntn_id");
        if (spcl === "l") {
        doc.scrollLeft -= 100;
        } else {
        doc.scrollLeft += 100;
        }
    }

    const handleModalGoBack = (step) => {
        if (step < currentStep) {
            setCurrentStep(step)
        }
    }

    const handlePriceSubmit = () => {
        setShowPriceError(false);
        const isValidStep1 = verManifestValidation.step1()
        if (!isValidStep1) return
        setCurrentStep(2)
    }

    const submitVerifyManifest = async () => {
        setShowStockError(false);
        const isValidStep2 = verManifestValidation.step2()
        if (!isValidStep2) return;
        try {
            let tpData = {}

            if (detail?.taxClass == gst) {
                tpData = {
                    _id: lead,
                    purchase_price: verTrPrice,
                };
            } else {
                tpData = {
                    _id: lead,
                    purchase_price: verTrPrice,
                    taxClass: gst,
                };
            }
            tpData["receivedFrom"] = "tv_catalog"
            tpData["stock"] = Number(currentStock);
            const res = await api.product.addToExProduct(tpData)
            setCurrentStep(0)
            callbackResFun(res?.message)
        } catch (err) {
            alert.error(err)
        }
    }


    const verManifestValidation = {
        step1: () => {
            if (verTrPrice === undefined || verTrPrice === null || verTrPrice < 1) {
                setShowPriceError(true);
                // alert.info('Please enter a valid transfer price.')
                return false;
            }
            return true;
        },
        step2: () => {
            if (currentStock === undefined || currentStock === null || currentStock < 1 || currentStock === "") {
                setShowStockError(true);
                setStockError('Please enter a valid stock.');
                // alert.info('Please enter a valid stock.')
                return false;
            } else if (currentStock > 10000) {
                setShowStockError(true);
                setStockError('Stock quantity cannot exceed 10000.');
                return false;
            }
            return true;
        }
    }

    return (
        <Modal
            show={Popupvisible}
            className="updtProPopModal orderManVerModal"
            centered
        >
            <Modal.Header>
                {/* New design SL-1143  add image section in left and step section in right only steps changes image section fixed*/}
                {/* New design SL-1143 */}
                <p style={styles.verifyManifestPopup.vtpPara}>{variables.variables.productOpportunitiesOrderTitles[currentStep]}</p>
                <a className="close mt-1" onClick={() => {
                    Popupvisibilityfun(false)
                    setCurrentStep(0)
                }}>
                    &times;
                </a>

                {/* Step tabs old */}
                {/* <div style={styles.verifyManifestPopup.headerDiv}>
                    <>
                        <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 0 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(0)}>Step 1</button>
                        <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 1 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(1)}>Step 2</button>
                        <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 2 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(2)}>Step 3</button>
                    </>
                </div> */}
            </Modal.Header>
            <Modal.Body className="updtProPopModal_body p_3px">
                {/* <a className="close mt-1" onClick={() => {
                    Popupvisibilityfun(false)
                    setCurrentStep(0)
                }}>
                    &times;
                </a> */}
                {/* <p style={styles.verifyManifestPopup.vtpPara}>{variables.variables.productOpportunitiesOrderTitles[currentStep]}</p> */}

                {/* Product image + basic info row (shown in all steps) */}
                <Row className="" style={styles.verifyManifestPopup.popupWrap}>
                    <div className="col-md-3">
                        {/* {imageUrl ? (
                            <div
                                className="catalog-img-border"
                                style={{
                                    ...styles.verifyManifestPopup.imageBox,
                                    background: `url(${imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            />
                        ) : (
                            <div
                                className="catalog-img-border"
                                style={{
                                    ...styles.verifyManifestPopup.imageBox,
                                    background: `url(${fallbackImage})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            />
                        )} */}
                      <div className="category-popup-main-image">
                        {allImages && allImages.length > 0 && mainImg ? (
                        <>
                            <img
                            src={`https://s3.toolsvilla.com/${mainImg}`}
                            alt="Product"
                            onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            <div className="category-popup-pagination-dots">
                            {allImages.map((item, index) => (
                                <div
                                key={index}
                                onClick={() => changeImage(item, index)}
                                className={`category-popup-dot ${paginationIndex === index ? 'active' : ''}`}
                                />
                            ))}
                            </div>
                        </>
                        ) : (
                        <div className="category-popup-no-image">No Image Available</div>
                        )}
                    </div>

                    {/* Thumbnails */}
                    <div className="category-popup-thumbnails">
                        {allImages && allImages.length > 3 && (
                        <img
                            src="/left-slide-icon.webp"
                            className="category-popup-slider-icon"
                            alt="Previous"
                            onClick={() => scroll("l")}
                        />
                        )}
                        <div
                        className="category-popup-thumbnail-container"
                        id="category_popup_img_list_box_cntn_id"
                        >
                        {allImages?.map((item, index) => (
                            <div
                            key={index}
                            className={`category-popup-thumbnail ${paginationIndex === index ? 'active' : ''}`}
                            onClick={() => changeImage(item, index)}
                            >
                            <img
                                src={`https://s3.toolsvilla.com/${getCleanImagePath(item.image)}`}
                                alt={`Thumbnail ${index + 1}`}
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            </div>
                        ))}
                        </div>
                        {allImages && allImages.length > 3 && (
                        <img
                            src="/right-slide-icon.webp"
                            className="category-popup-slider-icon"
                            alt="Next"
                            onClick={() => scroll("r")}
                        />
                        )}
                    </div>
                    </div>
                    <div className="col-md-9 py-1">
                        {/* Step tabs */}
                        <div style={styles.verifyManifestPopup.headerDiv}>
                            <>
                                <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 0 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(0)}>Step 1</button>
                                <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 1 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(1)}>Step 2</button>
                                <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 2 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(2)}>Step 3</button>
                            </>
                        </div>

                        <p className="product-name ff_pop" style={styles.verifyManifestPopup.pName}>{productName}</p>
                        <p className="sku" style={styles.verifyManifestPopup.sku}>{detail?.SKU}</p>
                        <p className="sku" style={styles.verifyManifestPopup.sku}>{detail?.manufacturerName}</p>
                   

                {/* ── STEP 1 : Confirm Details ── */}
                {currentStep === 0 && <>

                    {/* Package Details Table */}
                    {/*detail?.pkgs && detail.pkgs.filter(p => p.status === "APPROVED").length > 0 && (() => {
                        const approvedPkgs = detail.pkgs
                            .filter(p => p.status === "APPROVED")
                            .map(pkg => ({
                                ...pkg,
                                packageWidthFront: (pkg.packageWidth / 30.48).toFixed(2),
                                packageHeightFront: (pkg.packageHeight / 30.48).toFixed(2),
                                packageLengthFront: (pkg.packageLength / 30.48).toFixed(2),
                            }));
                        return (
                            <div className="mt-2 mb-1">
                                <div style={pkgTableStyle.sectionTitle}>Package Details</div>
                                <div style={pkgTableStyle.wrapper}>
                                    <table style={pkgTableStyle.table}>
                                        <thead>
                                            <tr>
                                                <th style={pkgTableStyle.th}>Package</th>
                                                <th style={pkgTableStyle.th}>Name</th>
                                                <th style={pkgTableStyle.th}>Actual Wt (Kg)</th>
                                                <th style={pkgTableStyle.th}>After Pkg (Kg)</th>
                                                <th style={pkgTableStyle.th}>Dimensions (L×W×H Ft)</th>
                                                <th style={pkgTableStyle.th}>
                                                    Vol. Wt
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>(L×B×H)/5000</Tooltip>}
                                                    >
                                                        <i className="bi bi-info-circle ms-1" style={{ cursor: 'pointer' }}></i>
                                                    </OverlayTrigger>
                                                    {" "}(Kg)
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {approvedPkgs.map((pkg, idx) => (
                                                <tr key={idx}>
                                                    <td style={pkgTableStyle.td}>Package {idx + 1}</td>
                                                    <td style={pkgTableStyle.td}><strong>{pkg.productName}</strong></td>
                                                    <td style={pkgTableStyle.td}>{pkg.actualWeight}</td>
                                                    <td style={pkgTableStyle.td}>{pkg.weight}</td>
                                                    <td style={pkgTableStyle.td}>{pkg.packageLengthFront} × {pkg.packageWidthFront} × {pkg.packageHeightFront}</td>
                                                    <td style={pkgTableStyle.td}><strong>{pkg?.vWeight?.toFixed(2)}</strong></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                    })()*/}

                    <Row className="mt-1 po-details-popup">
                        {/* <div className="" dangerouslySetInnerHTML={{ __html: detail?.description }}></div>
                        {detail?.descriptionNew && detail?.descriptionNew.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <div className="title fs-13 mt-2 bold">{item?.title} : </div>
                                    <div
                                        className="desc fs-13"
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    />
                                    {item?.title === 'Specification' && detail?.specificationNew && detail?.specificationNew.length > 0 &&
                                        detail?.specificationNew.map((spec, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className="desc fs-14">
                                                    <ul className='mb-0'>
                                                        <li>{spec?.type?.name} : {spec?.name}{" "}{spec?.unit}</li>
                                                    </ul>
                                                </div>
                                            </React.Fragment>
                                        ))
                                    }
                                </React.Fragment>
                            )
                        })}
                        {!(detail?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && detail?.specificationNew && detail?.specificationNew !== "[]" && detail?.specificationNew.length > 0 && (
                            <div>
                                <div className="title fs-14 mb-1 mt-2 bold">Specifications : </div>
                                {detail?.specificationNew.map((item, index) => (
                                    <div key={index} className="desc fs-14">
                                        <ul className='mb-0'>
                                            <li>{item?.type?.name} : {item?.name}{" "}{item?.unit}</li>
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="pd_desc">
                            <div className="pd_long_desc">Short description</div>
                            <div className='pd_description'>
                                <div id="popupSpecification" dangerouslySetInnerHTML={{ __html: detail?.shortDescription }}></div>
                            </div>
                        </div> */}

                        <div className="category-popup-divider" />
                        {/* Short Description */}
                        {detail.shortDescription && (
                            <div className="category-popup-section">
                            <div className="category-popup-section-title">Short Description</div>
                            <div
                                className="category-popup-section-content"
                                dangerouslySetInnerHTML={{ __html: detail.shortDescription }}
                            />
                            </div>
                        )}

                        {/* Description */}
                        {detail.description && (
                            <div className="category-popup-section">
                            <div className="category-popup-section-title">Product Details</div>
                            <div
                                className="category-popup-section-content"
                                dangerouslySetInnerHTML={{ __html: detail.description }}
                            />
                            </div>
                        )}

                        {/* Additional Descriptions */}
                        {detail.descriptionNew?.map((item, index) => (
                            <div key={index} className="category-popup-section">
                            <div className="category-popup-section-title">{item?.title}</div>
                            <div
                                className="category-popup-section-content"
                                dangerouslySetInnerHTML={{ __html: item.description }}
                            />
                            {item?.title === 'Specification' && detail?.specificationNew?.length > 0 && (
                                <ul className="category-popup-spec-list">
                                {detail.specificationNew.map((spec, idx) => (
                                    <li key={idx}>
                                    {spec?.type?.name}: {spec?.name} {spec?.unit}
                                    </li>
                                ))}
                                </ul>
                            )}
                            </div>
                        ))}

                        {/* Specifications (if not already shown) */}
                        {!(detail?.descriptionNew || []).some(
                            obj => obj.title === "Specifications" || obj.title === "Specification"
                        ) && detail?.specificationNew?.length > 0 && (
                            <div className="category-popup-section">
                            <div className="category-popup-section-title">Specifications</div>
                            <ul className="category-popup-spec-list">
                                {detail.specificationNew.map((item, index) => (
                                <li key={index}>
                                    {item?.type?.name}: {item?.name} {item?.unit}
                                </li>
                                ))}
                            </ul>
                            </div>
                        )}
                    </Row>

                    <p style={styles.verifyManifestPopup.endBtnContainer}>
                        <button style={styles.verifyManifestPopup.submitBtn} onClick={() => setCurrentStep(1)}>Confirm & Proceed</button>
                    </p>                    
                </>}


                {/* ── STEP 2 : Transfer Price ── */}
                {currentStep === 1 && <>
                    <Row className="text-center mt-1">
                        <div className="col-12">
                            {/* Show other seller's lowest price if available */}
                            {/* lowestPrice && (
                                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                    <span style={styles.verifyManifestPopup.lowestPriceTag}>
                                        <i className="bi bi-tag-fill me-1"></i>
                                        Other Seller's Price: ₹{Math.round(lowestPrice)}
                                    </span>
                                </div>
                            )*/}

                            <form className="">
                                {/* Show other seller's lowest price if available - FIRST */}
                                {lowestPrice && (
                                    <label style={styles.verifyManifestPopup.label}>
                                        <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                            <i className="bi bi-tag-fill me-1"></i> Other Seller's Price :
                                        </span>
                                        <span className="ms-2" style={styles.verifyManifestPopup.sUpdateContainer}>
                                            <span style={{ ...styles.verifyManifestPopup.lowestPriceTag, margin: 0 }}>
                                            
                                                ₹{Math.round(lowestPrice)}
                                            </span>
                                        </span>
                                    </label>
                                )}

                                {/* Transfer Price - SECOND */}
                                <label style={styles.verifyManifestPopup.label}>
                                    <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                        Transfer Price (incl. {gst}% GST) :
                                    </span>
                                    <span className="position-relative ms-2" style={styles.verifyManifestPopup.sUpdateContainer}>
                                        <span style={styles.verifyManifestPopup.rsLabel}>
                                            <i className="bi bi-currency-rupee" style={{ fontWeight: 'bold' }}></i>
                                        </span>
                                        <input
                                            type="number"
                                            autoComplete="off"
                                            minLength="1"
                                            value={verTrPrice ?? ""}
                                            style={styles.verifyManifestPopup.tpInput}
                                            required
                                            onChange={(e) => setVerTrPrice(e.target.value)}
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="0"
                                        />
                                        {showPriceError &&
                                            <span style={styles.verifyManifestPopup.stpErrorMsg} className='text-danger'>Please enter a valid transfer price</span>
                                        }
                                    </span>
                                </label>

                                {/* Select GST - THIRD */}
                                <label style={styles.verifyManifestPopup.label}>
                                    <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                        Select GST % :
                                    </span>
                                    <span className="position-relative ms-2" style={styles.verifyManifestPopup.sUpdateContainer}>
                                        <select
                                            style={styles.verifyManifestPopup.gstInput}
                                            value={gst}
                                            onChange={(e) => setGst(e.target.value)}
                                        >
                                            {variables?.variables?.gstValues.map((item, index) => (
                                                <option key={index} value={item}>{item}</option>
                                            ))}
                                        </select>
                                    </span>
                                </label>

                            </form>
                        </div>
                    </Row>
                    <p style={styles.verifyManifestPopup.endBtnContainer}>
                        <button style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(0)}>Back</button>
                        <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => handlePriceSubmit()}>Confirm and Proceed</button>
                    </p>
                </>}


                {/* ── STEP 3 : Stock ── */}
                {currentStep === 2 && <>
                    <Row className="text-center mt-1">
                        <div className="col-12">
                            <form className="">
                                <label style={styles.verifyManifestPopup.label}>
                                    <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                        Current Stock :
                                    </span>
                                    <span className="position-relative ms-2" style={styles.verifyManifestPopup.sUpdateContainer}>
                                        <input
                                            type="number"
                                            autoComplete="off"
                                            minLength="1"
                                            value={currentStock ?? ""}
                                            style={styles.verifyManifestPopup.cStockInput}
                                            required
                                            onChange={(e) => setCurrentStock(e.target.value)}
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="0"
                                        />

                                        {showStockError &&
                                            <span style={styles.verifyManifestPopup.stpErrorMsg} className='text-danger'>{stockError}</span>
                                        }
                                    </span>
                                </label>
                            </form>
                        </div>
                    </Row>
                    <p style={styles.verifyManifestPopup.endBtnContainer}>
                        <button style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(1)}>Back</button>
                        <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => submitVerifyManifest()}>Submit</button>
                    </p>
                </>}

                 </div>
                </Row>

            </Modal.Body>
        </Modal>
    )
}
export default AddProductFromCataloguePopup